/* =========================================================
   ROVIAN V3 — comportamiento compartido de las secciones de landing
   - Barra de progreso de carruseles
   - Videos que se reproducen solos al verse en pantalla
   - Botones CTA: bajan al producto o agregan al carrito
   - FAQ: una pregunta abierta a la vez
   ========================================================= */
(function () {
  if (window.__rxV3) return;
  window.__rxV3 = true;

  function initRails(root) {
    root.querySelectorAll('[data-rx-rail]').forEach(function (rail) {
      if (rail.dataset.rxInit) return;
      rail.dataset.rxInit = '1';
      var t = rail.querySelector('.rx-rail-track');
      var bar = rail.querySelector('.rx-rail-bar');
      var b = bar && bar.querySelector('i');
      if (!t || !b) return;
      var upd = function () {
        var ratio = Math.min(1, t.clientWidth / Math.max(1, t.scrollWidth));
        bar.style.display = ratio >= 0.999 ? 'none' : '';
        b.style.width = ratio * 100 + '%';
        var max = t.scrollWidth - t.clientWidth;
        var prog = max > 0 ? t.scrollLeft / max : 0;
        b.style.transform = 'translateX(' + prog * (1 / ratio - 1) * 100 + '%)';
      };
      t.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      var card = v.closest('.rx-vcard');
      if (en.isIntersecting) {
        if (v.preload === 'none') v.preload = 'auto';
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        if (card) card.classList.add('is-playing');
      } else {
        v.pause();
        if (card) card.classList.remove('is-playing');
      }
    });
  }, { threshold: 0.35 }) : null;

  function initVideos(root) {
    root.querySelectorAll('video[data-rx-autoplay]').forEach(function (v) {
      if (v.dataset.rxInit) return;
      v.dataset.rxInit = '1';
      v.muted = true;
      if (io) io.observe(v); else { v.autoplay = true; }
    });
  }

  function productEl() {
    return document.querySelector('[data-rv-product]') || document.getElementById('MainContent');
  }

  function initCtas(root) {
    root.querySelectorAll('[data-rx-cta]').forEach(function (a) {
      if (a.dataset.rxInit) return;
      a.dataset.rxInit = '1';
      a.addEventListener('click', function (e) {
        var mode = a.dataset.rxCta;
        if (mode === 'link') return;
        var p = productEl();
        if (!p) return;
        e.preventDefault();
        if (mode === 'comprar') {
          var btn = p.querySelector('[data-atc]');
          if (btn) { btn.click(); return; }
        }
        var y = p.getBoundingClientRect().top + window.pageYOffset - 20;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }

  function initFaq(root) {
    root.querySelectorAll('[data-rx-acc]').forEach(function (g) {
      if (g.dataset.rxInit) return;
      g.dataset.rxInit = '1';
      var items = Array.prototype.slice.call(g.querySelectorAll('details'));
      items.forEach(function (it) {
        it.addEventListener('toggle', function () {
          if (!it.open) return;
          items.forEach(function (o) { if (o !== it) o.removeAttribute('open'); });
        });
      });
    });
  }

  function init(root) {
    root = root || document;
    initRails(root); initVideos(root); initCtas(root); initFaq(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();